module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6fVl3D/tc-custom/9781936070725.jpg?1737164547392",
      "alt": "This image is the cover for the book Black Music, Akashi Classics: Renegade Reprint Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Black Music, Akashi Classics: Renegade Reprint Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The essential collection of jazz writing by the celebrated poet and author of "), _c('i', [_vm._v("Blues People")]), _vm._v("—reissued with a new introduction by the author.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In the 1960s, LeRoi Jones—who would later be known as Amiri Baraka—was a pioneering jazz critic, articulating in real time the incredible transformations of the form taking place in the clubs and coffee houses of New York City. In "), _c('i', [_vm._v("Black Music, he sheds light on ")]), _vm._v("the brilliant young jazz musicians of the day: John Coltrane, Thelonious Monk, Miles Davis, Ornette Coleman, Cecil Taylor, Archie Shepp, Sun Ra, and others."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Combining firsthand immediacy with wide-ranging erudition, "), _c('i', [_vm._v("Black Music")]), _vm._v(" articulates the complexities of modern jazz while also sharing insights on the nature of jazz criticism, the creative process, and the development of a new way forward for black artists. This rich and vital collection is comprised of essays, reviews, interviews, liner notes, musical analyses, and personal impressions from 1959–1967."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “In "), _c('i', [_vm._v("Black Music")]), _vm._v(", Baraka wrote with ecstasy—highly informed and intricate—about ecstatically complex music.”—Richard Brody, "), _c('i', [_vm._v("The New Yorker")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      LeRoi Jones\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Akashic Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0